export const usersRoutes = (apiBase) => ({
  accessLevel: `${apiBase}/access-levels`,
  rol: `${apiBase}/roles`,
  saveRol: `${apiBase}/roles`,
  savePermissionRol: `${apiBase}/roles/permissions`,
  getRolePermissions: (idRol) => `${apiBase}/roles/permissions?idRol=${idRol}`,
  getAllUsers: `${apiBase}/users`,
  getUserById: (id) => `${apiBase}/user?id=${id}`,
  saveUser: `${apiBase}/user`,
  getVacunadores: `${apiBase}/users/vacunadores`,
});
